<template>
  <div>
    <table class="table table-striped table-bordered table-hover">
      <thead>
        <tr>
          <th>Nome</th>
          <th>TOTAL</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="indicacao in valores" :key="indicacao.nome">
          <td>{{ caixaAlta(indicacao.nome) }}</td>
          <td>{{ indicacao.total }}</td>
        </tr>
        <tr class="table-primary">
          <td>TOTAL INDICAÇÕES</td>
          <td>{{ total }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</template>

<script>
import * as formatadores from '@/utils/formatadores'

export default {
  name: 'IndicacaoMedicoTabela',
  props: {
    valores: {
      type: Array,
      required: true,
    },
    total: {
      type: Number,
      required: true,
    },
  },
  methods: {
    ...formatadores,
  },
}
</script>
